import React from "react";
import { navigate } from "raviger";
import * as auth from "../../backend/auth";

function PageNotFound() {
    const hasToken = !!auth.getAuthToken();

    function handleGoBack() {
        if (hasToken) {
            navigate('/');
        } else {
            navigate('/login');
        }
    }

    return (
        <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '100vh', backgroundColor: '#f5f7fa' }}>
            <div style={{
                marginBottom: 24
            }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="51" height="51" viewBox="0 0 51 51" fill="none">
                    <path d="M7.29084 49.5366H43.2458C46.7205 49.5366 49.5367 46.7205 49.5367 43.2457V7.29084C49.5367 3.81613 46.7205 1 43.2458 1H7.29084C3.81613 1 1 3.81613 1 7.29084V43.2457C1.00123 46.7205 3.81736 49.5366 7.29084 49.5366Z" stroke="#C00F0C" stroke-width="2" stroke-miterlimit="10" stroke-linejoin="round"/>
                    <path d="M40.7829 38.7773C40.6001 38.8406 40.4064 38.876 40.2066 38.876L10.3322 38.8869C9.70831 38.8869 9.12587 38.5519 8.81515 38.0108C8.50321 37.471 8.50324 36.7996 8.81396 36.2586L23.7432 10.381C24.0539 9.84121 24.6327 9.50489 25.259 9.50489C25.8829 9.50367 26.4641 9.83998 26.7761 10.3798L41.7236 36.2477C42.0356 36.7875 42.0368 37.4588 41.7248 37.9999C41.5116 38.3679 41.174 38.6408 40.7829 38.7773ZM11.1547 36.6595L39.3828 36.6498L10.3322 36.6595L25.2602 12.2076L11.1547 36.6595Z" fill="#C00F0C"/>
                    <path d="M25.269 31.5156C24.7036 31.5156 24.2381 31.0708 24.2125 30.5055L23.6082 20.3235C23.5655 19.3792 24.3198 18.5896 25.2653 18.5896C26.2109 18.5896 26.9652 19.378 26.9238 20.3223L26.3267 30.5055C26.2999 31.0696 25.8356 31.5156 25.269 31.5156Z" fill="white"/>
                    <path d="M26.3467 33.9693C26.3467 34.5639 25.8654 35.0464 25.2696 35.0464C24.675 35.0464 24.1924 34.5651 24.1924 33.9705C24.1924 33.3758 24.6737 32.8933 25.2696 32.8933C25.8642 32.8933 26.3467 33.3746 26.3467 33.9693Z" fill="white"/>
                </svg>
            </div>
            <h1 style={{ fontSize: '32px', fontWeight: 500, color: '#111827', marginBottom: 16 }}>404 Error</h1>
            <p style={{ fontSize: '16px', fontWeight: 600, color: '#1e1e1e', marginBottom: 4 }}>
                Oops! We could not find the page your were looking for.
            </p>
            <p style={{ fontSize: '14px', color: '#1e1e1e', marginBottom: 24 }}>
                Please check whether you have used the correct URL.
            </p>
            {/* <button
                className="btn btn-primary"
                onClick={handleGoBack}
            >
                Go to Home
            </button> */}
        </div>
    );
}

export default PageNotFound;